<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['giftTks'],
      }"
      @click="configMainShow['giftTks'] = !configMainShow['giftTks']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>礼物答谢</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('giftTks', '礼物答谢')"
        >
          <el-switch v-model="configure.giftTks.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['giftTks'].timeRemaining)
          ? shoWDialogBuy(
              featureList['giftTks']['productKey'],
              '基础包',
              'giftTks'
            )
          : featureList['giftTks'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.giftTks.enable
          ? ''
          : toggleEnable('giftTks', '礼物答谢')
      "
      :class="{
        'no-buy': isNaN(featureList['giftTks'].timeRemaining),
        expired: featureList['giftTks'].timeRemaining <= 0,
        'shut-off': !configure.giftTks.enable,
      }"
    >
      <el-row>
        <el-col :span="5">感谢设定</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-radio v-model="configure.giftTks.giftTks1.tksAll" label="1"
              >&nbsp;感谢所有礼物</el-radio
            >
          </div>
          <div class="row-padding">
            <el-radio v-model="configure.giftTks.giftTks1.tksAll" label="0"
              >&nbsp;感谢金额≥</el-radio
            >
            <el-input-number
              v-model="configure.giftTks.giftTks1.money"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
              :precision="1"
            ></el-input-number
            >块钱的礼物
            <span class="article" style="margin-left: 10px">
              <a
                href="javascript:;"
                @click="isShowSpecialThanks = true"
                v-if="true"
                >#特殊感谢设定
              </a>
            </span>
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">
          一般礼物
          <br />句式池
        </el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.giftTks.giftTks1.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.giftTks.giftTks1.tpl[index]"
                  @input="checkEmpty(configure.giftTks.giftTks1.tpl, index)"
                  :labels="['userNick', 'gift', 'anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeGift1(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGiftTks1')"
            @focusout="singleInputFocusOut('addGiftTks1')"
          >
            <Editor
              v-model.trim="addGiftTks1"
              mode="edit"
              :labels="['userNick', 'gift', 'anchorNick']"
            ></Editor>
            <el-popover
              ref="addGiftTks1"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGiftTks1"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGiftTks1Tpl"
              v-popover:addGiftTks1
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">大额礼物</el-col>
        <el-col :span="19">
          金额≥
          <el-input-number
            v-model="configure.giftTks.giftTks2.money"
            :controls-position="isPC ? 'right' : ''"
            :min="0.1"
            size="mini"
            :precision="1"
          ></el-input-number
          >块钱的礼物
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">前置垫句</el-col>
        <el-col :span="19">
          <el-switch
            v-model="configure.giftTks.giftTksPreWords.preEnable"
          ></el-switch
          >开启大额礼物前置垫句，随机发送
          <el-input-number
            v-model="configure.giftTks.giftTksPreWords.preWordsCount"
            :controls-position="isPC ? 'right' : ''"
            :min="1"
            size="mini"
            :precision="0"
          ></el-input-number
          >条以内
          <div class="sentence-list">
            <div class="block-tag">
              会先随机发送下列句式铺垫情感，再接大额感谢句式
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.giftTks.giftTksPreWords
                  .preTpl"
                :key="index"
              >
                <Editor
                  v-model="configure.giftTks.giftTksPreWords.preTpl[index]"
                  @input="
                    checkEmpty(configure.giftTks.giftTksPreWords.preTpl, index)
                  "
                  :labels="['userNick', 'gift', 'anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removePreTpl(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('giftTks2PreTpl')"
            @focusout="singleInputFocusOut('giftTks2PreTpl')"
          >
            <Editor
              v-model.trim="giftTks2PreTpl"
              mode="edit"
              :labels="['userNick', 'gift', 'anchorNick']"
            ></Editor>
            <el-popover
              ref="giftTks2PreTpl"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.giftTks2PreTpl"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGiftTks2PreTpl"
              v-popover:giftTks2PreTpl
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          大额礼物
          <br />句式池
        </el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.giftTks.giftTks2.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.giftTks.giftTks2.tpl[index]"
                  @input="checkEmpty(configure.giftTks.giftTks2.tpl, index)"
                  :labels="['userNick', 'gift', 'anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeFigt2(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addGiftTks2')"
            @focusout="singleInputFocusOut('addGiftTks2')"
          >
            <Editor
              v-model.trim="addGiftTks2"
              mode="edit"
              :labels="['userNick', 'gift', 'anchorNick']"
            ></Editor>
            <el-popover
              ref="addGiftTks2"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addGiftTks2"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addGiftTks1Tp2"
              v-popover:addGiftTks2
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">礼物别名</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-button
              type="primary"
              size="small"
              @click="isShowGiftAliasList = true"
              >礼物别名设定</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <!-- <el-row v-if="true" id="subscribe">
        <el-col :span="5">礼盒设定</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.giftBoxTks"></el-switch
            >感谢礼盒
            不感谢礼盒（只感谢抽出来的礼物）
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div> -->
      <el-row>
        <el-col :span="5">活动中奖</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.miniAction.enable"></el-switch
            >游乐园中奖
          </div>
          <div v-show="configure.giftTks.miniAction.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.miniAction.tpl"
                    @input="checkEmpty(configure.giftTks.miniAction.tpl)"
                    :labels="['userNick', 'award']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row v-if="true">
        <el-col :span="5">其他设置</el-col>
        <el-col :span="19">
          <div
            class="row-padding"
            @click="
              !accountList[ticket] ||
              (accountList[ticket] && accountList[ticket].user.accountType != 1)
                ? subscribeClick()
                : ''
            "
            v-if="whiteidEnable"
          >
            <el-switch
              v-model="configure.giftTks.subscribe.enable"
              :disabled="
                !accountList[ticket] ||
                  (accountList[ticket] &&
                    accountList[ticket].user.accountType != 1)
              "
            ></el-switch
            >感谢订阅(需要主播账号做场控)
          </div>
          <div v-show="configure.giftTks.subscribe.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.subscribe.tpl[0]"
                    @input="checkEmpty(configure.giftTks.subscribe.tpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.giftBoxTks"></el-switch
            >感谢魔法石（上上签、小紫本）
            <!-- 不感谢礼盒（只感谢抽出来的礼物） -->
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.shareTks.enable"></el-switch
            >感谢分享直播间
          </div>
          <div v-show="configure.giftTks.shareTks.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.shareTks.tpl[0]"
                    @input="checkEmpty(configure.giftTks.shareTks.tpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.nobleOpen.enable"></el-switch
            >感谢开通贵族
          </div>
          <div v-show="configure.giftTks.nobleOpen.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.nobleOpen.tpl[0]"
                    @input="checkEmpty(configure.giftTks.nobleOpen.tpl, 0)"
                    :labels="['userNick', 'noble', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.giftTks.nobleContinue.enable"
            ></el-switch
            >感谢续费贵族
          </div>
          <div v-show="configure.giftTks.nobleContinue.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.nobleContinue.tpl[0]"
                    @input="checkEmpty(configure.giftTks.nobleContinue.tpl, 0)"
                    :labels="['userNick', 'noble', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.guard.enable"></el-switch
            >感谢开通守护
          </div>
          <div v-show="configure.giftTks.guard.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.guard.tpl[0]"
                    @input="checkEmpty(configure.giftTks.guard.tpl, 0)"
                    :labels="['userNick', 'guardLevel', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.giftTks.guardContinue.enable"
            ></el-switch
            >感谢续费守护
          </div>
          <div v-show="configure.giftTks.guardContinue.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.guardContinue.tpl[0]"
                    @input="checkEmpty(configure.giftTks.guardContinue.tpl, 0)"
                    :labels="['userNick', 'guardLevel', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding" v-if="false">
            <el-switch
              v-model="configure.giftTks.fansBadgeUp.enable"
            ></el-switch
            >恭喜粉丝牌子≥
            <el-input-number
              v-model="configure.giftTks.fansBadgeUp.level"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >的升级
          </div>
          <div class="row-padding" v-if="false">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.fansBadgeUp.tpl[0]"
                    @input="checkEmpty(configure.giftTks.fansBadgeUp.tpl, 0)"
                    :labels="['userNick', 'badge', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.giftTks.fansGetDiamond.enable"
            ></el-switch
            >恭喜授予粉钻
          </div>
          <div v-show="configure.giftTks.fansGetDiamond.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.fansGetDiamond.tpl[0]"
                    @input="checkEmpty(configure.giftTks.fansGetDiamond.tpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.tvResult.enable"></el-switch
            >恭喜上电视中奖
          </div>
          <div v-show="configure.giftTks.tvResult.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.tvResult.tpl[0]"
                    @input="checkEmpty(configure.giftTks.tvResult.tpl, 0)"
                    :labels="['userNick', 'award', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.giftTks.accompanyOrder.enable"
            ></el-switch
            >感谢陪玩下单
          </div>
          <div v-show="configure.giftTks.accompanyOrder.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.accompanyOrder.tpl[0]"
                    @input="checkEmpty(configure.giftTks.accompanyOrder.tpl, 0)"
                    :labels="['userNick', 'accompanySkill', 'accompanyTarget']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.giftTks.copyGaoBaiDengPai.enable"
            ></el-switch
            >复制“告白灯牌”内容
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.giftTks.superFans.enable"></el-switch
            >感谢开通超粉/超粉Plus
          </div>
          <div v-show="configure.giftTks.superFans.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.giftTks.superFans.tpl[0]"
                    @input="checkEmpty(configure.giftTks.superFans.tpl[0], 0)"
                    :labels="['userNick', 'anchorNick','award']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('礼物答谢', 'giftTks')"
          >「礼物答谢」恢复默认</el-button
        >
      </div>
    </div>
    <el-dialog
      :title="`特别感谢设定`"
      :width="isPC ? '540px' : '95%'"
      :visible.sync="isShowSpecialThanks"
      v-if="isShowSpecialThanks"
    >
      <div class="block-tag">以下礼物不受感谢设定的金额限制，均会感谢。</div>
      <div class="special-list-header">
        <div>礼物</div>
        <div>数量</div>
        <div>特殊感谢</div>
      </div>
      <div class="sentence-list" style="margin-top: 10px">
        <ul v-if="configure.giftTks.specialGift.length">
          <li
            v-for="(item, index) in configure.giftTks.specialGift"
            :key="index"
          >
            <div class="text-col3-editor no-tag">
              <div class="input-wrap">
                <el-select v-model="item.giftName" placeholder="请选择">
                  <el-option-group
                    v-for="group in giftSelectOptions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(groupitem, index) in group.options"
                      :key="index"
                      :label="groupitem.label"
                      :value="groupitem.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
                <input
                  type="number"
                  placeholder="数量..."
                  v-model="item.giftCount"
                />
                <div class="edit" @click="showSpecialThanksEdit(index, 'old')">
                  <i
                    slot="reference"
                    class="el-icon-edit"
                    :class="{
                      isEdit: item.tpl.length,
                    }"
                  ></i>
                </div>
              </div>
            </div>
            <i class="fa-window-close" @click="removeSpecialGift(index)"></i>
          </li>
        </ul>
      </div>
      <div class="sentence-add">
        <div class="text-col3-editor no-tag">
          <div class="input-wrap">
            <el-select v-model="giftName" placeholder="请选择">
              <el-option-group
                v-for="group in giftSelectOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="(groupitem, index) in group.options"
                  :key="index"
                  :label="groupitem.label"
                  :value="groupitem.value"
                ></el-option>
              </el-option-group>
            </el-select>
            <input type="number" placeholder="数量..." v-model="giftNumber" />
            <div class="edit" @click="showSpecialThanksEdit(0, 'new')">
              <i
                slot="reference"
                class="el-icon-edit"
                :class="{
                  isEdit: giftTpl.length,
                }"
              ></i>
            </div>
          </div>
          <el-button size="small" @click="addSpecialThanks">添加</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="`礼物别名设定`"
      :width="isPC ? '540px' : '95%'"
      :visible.sync="isShowGiftAliasList"
      v-if="isShowGiftAliasList"
    >
      <div class="sentence-list">
        <ul v-if="configure.giftTks.giftAlias.length">
          <li v-for="(item, index) in configure.giftTks.giftAlias" :key="index">
            <div class="text-col2-editor no-tag">
              <div class="input-wrap">
                <el-select v-model="item.name" placeholder="请选择">
                  <el-option-group
                    v-for="(group, i) in giftSelectOptions"
                    :key="i"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(groupitem, index) in group.options"
                      :key="index"
                      :label="groupitem.label"
                      :value="groupitem.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
                <input
                  type="text"
                  placeholder="别名..."
                  v-model="item.aliasName[0]"
                />
              </div>
            </div>
            <i class="fa-window-close" @click="removeGiftAliasList(index)"></i>
          </li>
        </ul>
      </div>
      <div class="sentence-add">
        <div class="text-col2-editor no-tag">
          <div class="input-wrap">
            <el-select v-model="giftName" placeholder="请选择">
              <el-option-group
                v-for="group in giftSelectOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="(groupitem, index) in group.options"
                  :key="index"
                  :label="groupitem.label"
                  :value="groupitem.value"
                ></el-option>
              </el-option-group>
            </el-select>
            <input type="text" placeholder="别名..." v-model="giftCustom" />
          </div>
          <el-button size="small" @click="addGiftAliasList">添加</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="`特别感谢句子`"
      :width="isPC ? '540px' : '95%'"
      :visible.sync="isShowSpecialThanksEdit"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="specialThanksEditBeforeClose"
      v-if="isShowSpecialThanksEdit"
    >
      <div
        class="sentence-add"
        tabindex="99"
        @focusin="eleFocusIn('addSpecialThanksEditTpl')"
        @focusout="
          singleInputFocusOutOfaddSpecialThanksEdit(
            'addSpecialThanksEditTpl',
            false
          )
        "
      >
        <Editor
          v-model="specialThanksEditText"
          mode="edit"
          @input="checkEmpty(giftTpl, 0)"
          :labels="['userNick', 'gift', 'anchorNick']"
        ></Editor>
        <el-button
          size="small"
          @click="addSpecialThanksEditTpl"
          v-popover:addSpecialThanksEditTpl
          >保存句子</el-button
        >
        <el-popover
          ref="addSpecialThanksEditTpl"
          placement="bottom-end"
          width="280"
          v-model="isShowInputBlurTips.addSpecialThanksEditTpl"
          trigger="manual"
          :popper-options="{
            boundariesElement: 'body',
            adaptive: false,
          }"
        >
          <p>记得点“保存句子”才会生效哦</p>
        </el-popover>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {} from "@/api/index";
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      // 特别感谢设定弹窗
      isShowSpecialThanks: false,

      addGiftTks1: "", // 小额礼物 句式输入框
      giftTks2PreTpl: "", // 前置垫句 句式输入框
      addGiftTks2: "", // 大额礼物 句式输入框
      // 礼物别名设定弹窗
      isShowGiftAliasList: false,
      // 特殊礼物感谢句子编辑弹窗
      isShowSpecialThanksEdit: false,
      specialThanksEditType: "new",
      specialThanksEditText: "",
      specialThanksEditIndex: 0,
      editTimer: null,
      // 礼物别名选项
      giftName: "",
      // 特别感谢数量
      giftNumber: "",
      // 特别感谢句式
      giftTpl: [],
      giftCustom: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    accountList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ticket: {
      type: String,
      default: "",
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
    giftSelectOptions: {
      type: Array,
      default: require("@/assets/js/giftSelectOptions.json"),
    },
  },
  watch: {
    isShowSpecialThanksEdit(val) {
      if (!val) {
        this.specialThanksEditClose();
      }
    },
  },
  mounted() {
    this.subscribeFormat();
    this.specialGiftFormat();
  },
  methods: {
    removeGift1(index) {
      this.configure.giftTks.giftTks1.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除小额礼物答谢句式
    addGiftTks1Tpl() {
      if (this.addGiftTks1 === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.giftTks.giftTks1.tpl.unshift(this.addGiftTks1);
        this.addGiftTks1 = "";
        this.$message.success("添加成功");
      }
    }, // 小额礼物句式添加
    removePreTpl(index) {
      this.configure.giftTks.giftTksPreWords.preTpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除前置垫句
    addGiftTks2PreTpl() {
      if (this.giftTks2PreTpl === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.giftTks.giftTksPreWords.preTpl.unshift(
          this.giftTks2PreTpl
        );
        this.giftTks2PreTpl = "";
        this.$message.success("添加成功");
      }
    }, // 前置垫句句式添加

    removeFigt2(index) {
      this.configure.giftTks.giftTks2.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除大额礼物答谢
    addGiftTks1Tp2() {
      if (this.addGiftTks2 === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.giftTks.giftTks2.tpl.unshift(this.addGiftTks2);
        this.addGiftTks2 = "";
        this.$message.success("添加成功");
      }
    }, // 大额礼物句式添加
    subscribeClick() {
      this.$message.error("您的场控号不是主播号，无法感谢订阅者");
    },
    removeSpecialGift(index) {
      this.configure.giftTks.specialGift.splice(index, 1);
      this.configure.giftTks.specialGift = this.configure.giftTks.specialGift;
      this.$message.success("删除成功");
    }, // 删除特别感谢礼物
    addSpecialThanks() {
      if (this.giftNumber <= 0) {
        this.$message.warning("数量不能为空哦");
        return;
      }
      if (this.giftName === "") {
        this.$message.warning("礼物不能为空哦");
        return;
      }
      let isNameRepeat = false;
      if (this.configure.giftTks.specialGift.length) {
        this.configure.giftTks.specialGift.forEach((val, index) => {
          if (val.giftName == this.giftName) {
            isNameRepeat = true;
          }
          if (this.configure.giftTks.specialGift.length == index + 1) {
            if (!isNameRepeat) {
              this.configure.giftTks.specialGift.unshift({
                giftName: this.giftName,
                giftCount: this.giftNumber,
                tpl: this.giftTpl,
              });
              this.giftName = "";
              this.giftNumber = "";
              this.giftTpl = [];
              this.$message.success("添加成功");
            } else {
              this.$message.warning("该礼物已添加");
            }
          }
        });
      } else {
        this.configure.giftTks.specialGift = [];
        this.configure.giftTks.specialGift.unshift({
          giftName: this.giftName,
          giftCount: this.giftNumber,
          tpl: this.giftTpl,
        });
        this.giftName = "";
        this.giftNumber = "";
        this.giftTpl = [];
        this.$message.success("添加成功");
      }
    }, //特别感谢添加
    addGiftAliasList() {
      if (this.giftName === "" && this.giftCustom === "") {
        this.$message.warning("不能为空哦");
      } else {
        let isNameRepeat = false;
        if (this.configure.giftTks.giftAlias.length) {
          this.configure.giftTks.giftAlias.forEach((val, index) => {
            if (val.name == this.giftName) {
              isNameRepeat = true;
            }
            if (this.configure.giftTks.giftAlias.length == index + 1) {
              if (!isNameRepeat) {
                this.configure.giftTks.giftAlias.unshift({
                  name: this.giftName,
                  aliasName: [this.giftCustom],
                });
                this.giftName = "";
                this.giftCustom = "";
                this.$message.success("添加成功");
              } else {
                this.$message.warning("该礼物已添加别名");
              }
            }
          });
        } else {
          this.configure.giftTks.giftAlias = [];
          this.configure.giftTks.giftAlias.unshift({
            name: this.giftName,
            aliasName: [this.giftCustom],
          });
          this.giftName = "";
          this.giftCustom = "";
          this.$message.success("添加成功");
        }
      }
    }, //礼物别名添加
    removeGiftAliasList(index) {
      this.configure.giftTks.giftAlias.splice(index, 1);
      this.configure.giftTks.giftAlias = this.configure.giftTks.giftAlias;
      this.$message.success("删除成功");
    }, // 删除礼物别名
    subscribeFormat() {
      if (
        !this.accountList[this.ticket] ||
        (this.accountList[this.ticket] &&
          this.accountList[this.ticket].user.accountType != 1)
      ) {
        this.configure.giftTks.subscribe.enable = JSON.parse(
          this.featureList.giftTks.defaultData
        ).subscribe.enable;
      }
    },
    specialGiftFormat() {
      this.configure.giftTks.specialGift.forEach((val) => {
        if (!val.tpl) {
          this.$set(val, "tpl", new Array());
        }
      });
      this.$forceUpdate();
    },
    showSpecialThanksEdit(index, type = "new") {
      this.specialThanksEditIndex = index;
      this.specialThanksEditType = type;
      if (type == "old" && this.configure.giftTks.specialGift[index].tpl[0]) {
        this.specialThanksEditText = this.configure.giftTks.specialGift[
          index
        ].tpl[0];
      }
      this.isShowSpecialThanksEdit = true;
    },
    addSpecialThanksEditTpl() {
      if (this.specialThanksEditType == "new") {
        this.giftTpl[0] = this.specialThanksEditText;
      }
      if (this.specialThanksEditType == "old") {
        this.configure.giftTks.specialGift[
          this.specialThanksEditIndex
        ].tpl[0] = this.specialThanksEditText;
      }
      this.isShowSpecialThanksEdit = false;
    },
    specialThanksEditBeforeClose() {
      if (
        (this.specialThanksEditType == "new" && this.specialThanksEditText) ||
        (this.specialThanksEditType == "old" &&
          ((this.configure.giftTks.specialGift[this.specialThanksEditIndex]
            .tpl[0] &&
            this.specialThanksEditText !=
              this.configure.giftTks.specialGift[this.specialThanksEditIndex]
                .tpl[0]) ||
            (!this.configure.giftTks.specialGift[this.specialThanksEditIndex]
              .tpl[0] &&
              this.specialThanksEditText)))
      ) {
        this.$confirm(`感谢句子还没保存，是否关闭弹窗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.isShowSpecialThanksEdit = false;
          })
          .catch(() => {});
      } else {
        this.isShowSpecialThanksEdit = false;
      }
    },
    specialThanksEditClose() {
      this.specialThanksEditIndex = 0;
      this.specialThanksEditType = "new";
      this.specialThanksEditText = "";
      this.isShowInputBlurTips.addSpecialThanksEditTpl = false;
      clearTimeout(this.editTimer);
      this.$forceUpdate();
    },
    singleInputFocusOutOfaddSpecialThanksEdit(inputTitle, isScroll = true) {
      this.editTimer = setTimeout(() => {
        if (!this.isShowSpecialThanksEdit) {
          return;
        }
        if (this[inputTitle]) {
          this.eleFocusOut(inputTitle, isScroll);
        }
      }, 2e3);
    },
  },
};
</script>
